import * as React from "react"
import { toast } from "react-toastify"
import CollectionSite from "../../api/Location/LocationModel/CollectionSite"
import { stateAbbreviationsToCommonWealthState, StateToTimeZone } from "../../api/Location/LocationModel/CommonWealthStateTextMapping"
import { APIError } from "../../api/ObservableFromFetch"
import { GetOrderRequest, SetFFTestDetailVendor, SetTestDetailVendor, SetTestDetailVendorParameters } from "../../api/OrderRequests/SSOOrderRequest"
import { StorageKey } from "../../config/Constants"
import { GetSSOToken } from "../../storage/AuthToken"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import OrderFinish from "../OrderRequests/OrderFinish"
import ProcessingModal from "../ProcessingModal"
import SiteSearch from "../SiteSearch/SiteSearch"
import {AuthFormByToken} from "../../api/OrderResults/AuthForm"
import { Subscription } from "rxjs"
import printPdf,{showPdf} from "../../utils/printPdf"

interface GetAuthFormPageState {
  formFoxTestAN: number
  isLoading: boolean
  ssoToken: string
  spinnerMessage: string
}
export default class GetAuthFormPage extends React.PureComponent<{}, GetAuthFormPageState> {
  state: GetAuthFormPageState = {
    formFoxTestAN: 0,
    isLoading: true,
    ssoToken: GetSSOToken(),
    spinnerMessage: "Data is loading..."
  }
  loadSubscription?: Subscription

  componentWillUnmount() {
    this.loadSubscription && this.loadSubscription.unsubscribe()
  }
  componentDidMount() {
    this.loadAuthFormPdf()
  }

  loadAuthFormPdf = () => {
    this.setState({isLoading:true, spinnerMessage: "Data is loading..."})
    this.loadSubscription && this.loadSubscription.unsubscribe()
    const params = {
      requestToken: this.state.ssoToken,
      FormFoxTestAN: 0
    }
    this.loadSubscription = AuthFormByToken(params).subscribe(
      data => {
        this.setState({isLoading:false, spinnerMessage:""})
        showPdf(data)
      },
      error => {
        this.handleAPIError(error, { isLoading: false, spinnerMessage: "" })
      }
    )
}


  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  render() {
    const { isLoading, formFoxTestAN } = this.state;
    return <AppPageWrapper showNav={false}>
      {(isLoading) && <ProcessingModal message={this.state.spinnerMessage} />}
    </AppPageWrapper>
  }
}
